import React, { useRef, useState } from 'react'
import { BsClipboard } from 'react-icons/bs'
import styles from './Paste.module.scss'

export default function Paste({ userInput, setUserInput, setLoadingError }) {
  const [focused, setFocused] = useState(false)
  const textareaRef = useRef(null)
  const isEmpty = !userInput

  return (
    <div className={styles.wrapper} onClick={() => textareaRef.current?.focus()}>
      <textarea
        ref={textareaRef}
        className={styles.textarea}
        value={userInput ?? ''}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(e) => {
          setUserInput(e.target.value)
          setLoadingError(null)
        }}
      />
      {isEmpty && !focused && (
        <div className={styles.emptyHint}>
          <BsClipboard className={styles.emptyHintIcon} />
          <span className={styles.emptyHintText}>Paste your data here</span>
          <span className={styles.emptyHintSub}>CSV, TSV or JSON — just paste and go</span>
        </div>
      )}
    </div>
  )
}
